import { render, staticRenderFns } from "./inner_sidebar.vue?vue&type=template&id=8df56b7e&scoped=true&"
import script from "./inner_sidebar.vue?vue&type=script&lang=js&"
export * from "./inner_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./inner_sidebar.vue?vue&type=style&index=0&id=8df56b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df56b7e",
  null
  
)

export default component.exports